import { ProductTrialsWebComponent } from './component/ProductTrialsWebComponent';

export { ProductTrialsWebComponent };
